import { Pipe } from '@angular/core';

/**
 * Automatically create hyperlinks in a given bunch of HTML
 */
@Pipe({ name: 'filter' })
export class FilterPipe {
    transform<T>(value: T[], query: string): T[] {
        if (!value || !query)
            return value;
        return value.filter(x => JSON.stringify(x).includes(query));
    }
}